import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { FetchResponse } from '@cian/http-api';

import { IApplicationContext } from '../../types/applicationContext';
import {
  fetchGetSearchTypes,
  TGetSearchTypesResponse,
} from '../../repositories/newbuilding-promos/v1/get-search-types';
import { TPromoSearchTypes } from 'shared/types/promoSearchTypes';

interface IFetchPromoSearchTypesParams {
  subdomain: string;
  regionId: number;
}

export async function fetchPromoSearchTypes(
  { httpApi, logger }: IApplicationContext,
  parameters: IFetchPromoSearchTypesParams,
): Promise<TPromoSearchTypes | null> {
  try {
    const promoSearchTypes = (await fetchGetSearchTypes({
      httpApi,
      parameters,
    })) as FetchResponse<TGetSearchTypesResponse>;

    if (promoSearchTypes.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: promoSearchTypes.statusCode,
        domain: 'fetchPromoSearchTypes',
        message: promoSearchTypes.response.message as string,
      });
    }

    return promoSearchTypes.response;
  } catch (error) {
    logger.error(
      {
        ...error,
        details: {
          microserviceName: 'newbuilding-promos',
          pathApi: '/public/v1/get-search-types/',
          parameters: JSON.stringify(parameters),
        },
      },
      {
        degradation: 'Запрос типов акции',
      },
    );

    return null;
  }
}
